import { render, staticRenderFns } from "./DelegationForm.vue?vue&type=template&id=550cf70a&"
import script from "./DelegationForm.vue?vue&type=script&lang=js&"
export * from "./DelegationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports